import { render, staticRenderFns } from "./PingDot.vue?vue&type=template&id=454f4292&"
import script from "./PingDot.vue?vue&type=script&lang=js&"
export * from "./PingDot.vue?vue&type=script&lang=js&"
import style0 from "./PingDot.vue?vue&type=style&index=0&id=454f4292&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports